import { render, staticRenderFns } from "./BattleReconnect.vue?vue&type=template&id=9365255e&scoped=true&lang=pug&"
import script from "./BattleReconnect.vue?vue&type=script&lang=js&"
export * from "./BattleReconnect.vue?vue&type=script&lang=js&"
import style0 from "./BattleReconnect.vue?vue&type=style&index=0&id=9365255e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365255e",
  null
  
)

export default component.exports